<template>
    <el-dialog
        title="历史采集数据"
        :model-value="modelValue"
        top="10vh"
        width="1100px"
        @open="dialogOpen"
        @close="closed"
        :close-on-click-modal="false"
    >
        <div class="tool-box">
            <el-radio-group v-model="search_days" @change="getChartData">
                <el-radio-button :label="7">近七天</el-radio-button>
                <el-radio-button :label="30">近一个月</el-radio-button>
                <el-radio-button :label="120">近四个月</el-radio-button>
            </el-radio-group>
        </div>
        <div class="line-chart" ref="lineChart" v-loading="loading"></div>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref } from 'vue'
import { getDeviceChart } from '@/api/heating/monitoring.js'
import * as echarts from 'echarts'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    deviceId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 弹窗打开
function dialogOpen() {
    line_chart = echarts.init(lineChart.value)
    line_chart.setOption({
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {},
        grid: {
            left: '50px',
            right: '50px',
            bottom: '0',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            axisTick: {
                alignWithLabel: true
            },
            axisLine: {
                show: true,
                lineStyle: {
                    width: 1,
                    type: 'solid',
                    shadowColor: '#6e7079'
                }
            },
            data: []
        },
        yAxis: [
            {
                name: '温度（℃）',
                nameTextStyle: {
                    padding: [0, 60, 0, 0]
                },
                type: 'value',
                min: 0,
                max: 100,
                minInterval: 1,
                axisLine: {
                    show: true,
                    lineStyle: {
                        width: 1,
                        type: 'solid',
                        shadowOffsetY: -30,
                        shadowColor: '#6e7079'
                    }
                }
            },
            {
                name: '湿度（%）',
                nameTextStyle: {
                    padding: [0, 0, 0, 80]
                },
                type: 'value',
                min: 0,
                max: 100,
                minInterval: 1,
                axisLine: {
                    show: true,
                    lineStyle: {
                        width: 1,
                        type: 'solid',
                        shadowOffsetY: -30,
                        shadowColor: '#6e7079'
                    }
                }
            }
        ],
        series: [
            {
                name: '温度（℃）',
                type: 'line',
                lineStyle: {
                    color: '#5470c6'
                },
                symbol: 'dot',
                itemStyle: {
                    normal: {
                        color: '#5470c6'
                    }
                },
                yAxisIndex: 0
            },
            {
                name: '湿度（%）',
                type: 'line',
                yAxisIndex: 1,
                lineStyle: {
                    color: '#e6a23c'
                },
                symbol: 'dot',
                itemStyle: {
                    // 设置线条上点的颜色（和图例的颜色）
                    normal: {
                        color: '#e6a23c'
                    }
                }
            }
        ]
    })

    getChartData()
}

// 查询日期范围
const search_days = ref(7)

// 表格数据
const chartData = ref([])
const loading = ref(false)
function getChartData() {
    loading.value = true
    getDeviceChart({
        type: 2,
        device_id: props.deviceId,
        days: search_days.value
    }).then((data) => {
        chartData.value = data
        draw_lineChart()
        loading.value = false
    })
}

const lineChart = ref(null)
let line_chart = null

function draw_lineChart() {
    const date_arr = []
    const temp_list = []
    const humidity_list = []
    chartData.value.forEach((item) => {
        date_arr.push(item.date)
        temp_list.push(item.avg_roomtemp)
        humidity_list.push(item.avg_humidity)
    })
    line_chart.setOption({
        xAxis: {
            data: date_arr
        },
        series: [
            {
                data: temp_list
            },
            {
                data: humidity_list
            }
        ]
    })
}

// 关闭
function closed() {
    chartData.value = []
    emits('update:modelValue', false)
}
</script>

<style scoped>
.tool-box {
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;
}
.line-chart {
    height: 400px;
}
</style>
